<template>
  <v-row justify="center" v-if="Object.keys(orderInfo).length != 0">
    <v-col cols="12" sm="10" md="10" lg="8" xl="6" align="center">
      <h2 class="title-underline" translate>{{ $t(["ORDER SUMMARY"]) }}</h2>

      <!-- <div placeholder="{{ 'Order Number' | translate }}"></div> -->
      <h3 v-show="this.orderInfo.status == 'Voided'" class="secondary--text">
        {{ $t(["Voided"]) }}
      </h3>

      <h3>
        {{ $t(["OrderNumber_Label"]) }}
        {{ orderInfo.orderNumberId }}
      </h3>

      <h3 class="mb-3">
        {{ $t(["PhoneNumber_Label"]) }}
        {{ orderInfo.phoneNumber }}
      </h3>

      <v-alert
        v-model="errorMsgAlert"
        close-text="Close Alert"
        class="alert-text my-5"
        color="error"
        dark
        dismissible
        ref="snackbarError"
      >
        {{ $t(errorMsg) }}
      </v-alert>

      <v-card class="card mb-5" v-show="orderInfo.type != 'RegisterAndDonate'">
        <v-col class="py-0" align="center">
          <h4 class="my-3" translate>{{ $t(["MERCHANDISE SUMMARY"]) }}</h4>

          <v-divider class="mx-5"></v-divider>

          <MerchandiseTable
            :orderCart="
              orderInfo.cart != undefined
                ? Object.values(JSON.parse(orderInfo.cart))
                : []
            "
          />
        </v-col>
      </v-card>

      <v-card class="card mb-5" v-show="this.orderInfo.status != 'Pending'">
        <v-col class="py-0">
          <TotalSummaryTable :tableData="totalSummaryTableData" />
        </v-col>
      </v-card>

      <v-card class="card">
        <v-col class="py-0" align="center">
          <h4 class="my-3" translate>{{ $t(["CUSTOMER INFORMATION"]) }}</h4>

          <v-divider class="mx-5"></v-divider>

          <!-- <div placeholder="{{ 'Registration' | translate }}"></div> -->
          <!-- <div placeholder="{{ 'Yes' | translate }}"></div> -->
          <!-- <div placeholder="{{ 'No' | translate }}"></div> -->
          <h3 class="my-3">
            {{ $t(["Registration_Label"]) }}
            {{
              this.orderInfo.selection == "Register and/or Donate" ||
              this.orderInfo.selection.includes("Registration")
                ? $t(["Yes"])
                : $t(["No"])
            }}
          </h3>

          <v-divider class="mx-5"></v-divider>

          <v-form ref="orderStatusSummaryForm">
            <v-row justify="center" class="my-3 mx-5" no-gutters>
              <div style="width: 350px">
                <v-text-field
                  :label="$t(['Phone Number'])"
                  v-model="orderInfo.phoneNumber"
                  type="tel"
                  class="centered-input error-field pt-3"
                  v-mask="'(###) ###-####'"
                  :readonly="
                    this.orderInfo.status == 'Pending' ||
                    this.orderInfo.status == 'Declined'
                      ? false
                      : true
                  "
                  :rules="rules.phoneNumber"
                  @click="selectAllText"
                  ref="textfieldInput"
                  dense
                >
                </v-text-field>
              </div>
            </v-row>
          </v-form>

          <v-divider class="mx-5 mb-5"></v-divider>

          <div
            v-if="
              this.orderInfo.type == 'Merchandise' &&
              this.orderInfo.status == 'Approved' &&
              this.orderInfo.merchTotal -
                this.orderInfo.refundData.refundAmount.approved.merchandise !=
                0
            "
          >
            <div class="d-flex flex-wrap justify-center">
              <v-btn
                class="btn-text btn-multiline mb-5"
                color="primary"
                width="250px"
                x-large
                :loading="competeBtnLoading"
                @click="completeOrder()"
              >
                <span class="text-wrap" translate>{{ $t(["Complete"]) }}</span>
              </v-btn>
            </div>

            <v-divider
              v-show="this.orderInfo.status == 'Approved' && this.total > 0"
              class="mx-5"
            ></v-divider>
          </div>

          <div
            v-show="
              this.orderInfo.status == 'Pending' ||
              this.orderInfo.status == 'Declined'
            "
          >
            <v-btn
              class="btn-text btn-multiline mb-5 justify-center"
              color="primary"
              min-width="200px"
              x-large
              :loading="resendBtnLoading"
              @click="resendOrder()"
            >
              <span class="text-wrap" translate>{{ $t(["Resend"]) }}</span>
            </v-btn>

            <v-dialog v-model="qrCodeDialog" width="400">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  class="btn-text btn-multiline mx-5 mb-5"
                  min-width="200px"
                  x-large
                  v-bind="attrs"
                  v-on="on"
                >
                  <span class="text-wrap" translate style="font-size: 0.95rem">
                    {{ $t(["Show QR Code"]) }}
                  </span>
                </v-btn>
              </template>

              <v-card class="card">
                <v-col class="pa-0" align="center">
                  <v-card-title class="white--text primary">
                    <h4 translate>{{ $t(["Order Form Url"]) }}</h4>
                  </v-card-title>

                  <v-img
                    :src="qrCodeUrl != '' ? qrCodeUrl : ''"
                    contain
                    width="250"
                  ></v-img>

                  <v-divider></v-divider>

                  <v-card-actions class="mr-5">
                    <v-spacer></v-spacer>
                    <v-btn
                      class="btn-text justify-center"
                      color="primary"
                      translate
                      @click="qrCodeDialog = false"
                    >
                      {{ $t(["Close"]) }}
                    </v-btn>
                  </v-card-actions>
                </v-col>
              </v-card>
            </v-dialog>

            <v-divider class="mx-5"></v-divider>
          </div>

          <v-row
            v-if="
              this.orderInfo.status == 'Pending' ||
              this.orderInfo.status == 'Declined' ||
              this.orderInfo.status == 'Approved' ||
              this.orderInfo.status == 'Completed'
            "
            class="my-5 mx-3"
            justify="center"
          >
            <v-btn
              v-show="
                this.orderInfo.status == 'Pending' ||
                this.orderInfo.status == 'Declined'
              "
              class="btn-text btn-multiline mx-3"
              color="secondary"
              min-width="200px"
              x-large
              outlined
              :loading="voidBtnLoading"
              @click="voidOrder()"
            >
              <span class="text-wrap" translate>
                {{ $t(["Void Order"]) }}
              </span>
            </v-btn>

            <v-btn
              v-show="
                (this.orderInfo.status == 'Approved' ||
                  this.orderInfo.status == 'Completed') &&
                this.total > 0
              "
              class="btn-text btn-multiline mx-3"
              color="secondary"
              width="250px"
              x-large
              outlined
              @click="goToRefundRequest()"
            >
              <span class="text-wrap" translate>
                {{ $t(["Request Refund"]) }}
              </span>
            </v-btn>
          </v-row>

          <div
            v-show="
              this.orderInfo.status == 'Pending' ||
              this.orderInfo.status == 'Declined'
            "
          >
            <v-divider class="mx-5"></v-divider>

            <h5 class="my-5 px-5">
              {{ formUrl }}?id={{ orderInfo.orderAliasId }}
            </h5>
          </div>
        </v-col>
      </v-card>

      <v-row class="mt-10" justify="center">
        <v-col cols="10" sm="8" xl="4" class="px-0">
          <v-btn
            class="btn-text btn-multiline"
            x-large
            block
            @click="backToOrderStatus()"
          >
            <span class="text-wrap" translate>
              {{ $t(["Back: Order Status"]) }}
            </span>
          </v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import { Auth } from "aws-amplify";
import QRCode from "qrcode";

import { useAuthenicationStore } from "../../store/authenication";
import { useStatusStore } from "../../store/status";

import MerchandiseTable from "@/app/components/MerchandiseTable.vue";
import TotalSummaryTable from "@/app/components/TotalSummaryTable.vue";

export default {
  name: "OrderStatusSummary",
  data: () => ({
    formUrl: "",
    selection: "",
    total: 0,
    orderInfo: {},
    totalSummaryTableData: {},
    errorMsgAlert: false,
    errorMsg: "",
    competeBtnLoading: false,
    resendBtnLoading: false,
    voidBtnLoading: false,
    qrCodeDialog: false,
    qrCodeUrl: "",
    rules: {
      phoneNumber: [],
    },
  }),
  components: {
    MerchandiseTable,
    TotalSummaryTable,
  },
  setup() {
    const authStore = useAuthenicationStore();
    const statusStore = useStatusStore();

    return {
      authStore,
      statusStore,
    };
  },

  async mounted() {
    this.formUrl = process.env.VUE_APP_FORM_URL;

    this.orderInfo =
      this.$route.params.data != undefined
        ? this.$route.params.data
        : this.statusStore.orderData;

    if (
      this.orderInfo.status != "Pending" &&
      this.orderInfo.status != "Declined" &&
      this.orderInfo.status != "Voided"
    ) {
      let refundedTotal =
        this.orderInfo.refundData.refundAmount.approved.merchandise +
        this.orderInfo.refundData.refundAmount.approved.donation;

      this.total =
        (this.orderInfo.merchTotal != undefined
          ? this.orderInfo.merchTotal
          : 0) +
        (this.orderInfo.formData.donationAmount != undefined
          ? this.orderInfo.formData.donationAmount
          : 0) -
        (refundedTotal != undefined ? refundedTotal : 0);

      this.totalSummaryTableData = {
        merchAmount:
          this.orderInfo.merchTotal != undefined
            ? this.orderInfo.merchTotal
            : 0,
        merchRefund:
          this.orderInfo.refundData.refundAmount.approved.merchandise !=
          undefined
            ? this.orderInfo.refundData.refundAmount.approved.merchandise
            : 0,
        merchTotal:
          (this.orderInfo.merchTotal != undefined
            ? this.orderInfo.merchTotal
            : 0) -
          (this.orderInfo.refundData.refundAmount.approved.merchandise !=
          undefined
            ? this.orderInfo.refundData.refundAmount.approved.merchandise
            : 0),
        donationAmount:
          this.orderInfo.formData.donationAmount != undefined
            ? this.orderInfo.formData.donationAmount
            : 0,
        donationRefund:
          this.orderInfo.refundData.refundAmount.approved.donation != undefined
            ? this.orderInfo.refundData.refundAmount.approved.donation
            : 0,
        donationTotal:
          (this.orderInfo.formData.donationAmount != undefined
            ? this.orderInfo.formData.donationAmount
            : 0) -
          (this.orderInfo.refundData.refundAmount.approved.donation != undefined
            ? this.orderInfo.refundData.refundAmount.approved.donation
            : 0),
        type: this.orderInfo.type,
      };
    } else {
      await this.generateQrCode();
    }
  },
  watch: {
    "$i18n.locale"() {
      this.$refs.orderStatusSummaryForm.resetValidation();
    },
  },
  methods: {
    selectAllText() {
      if (
        this.orderInfo.status == "Pending" ||
        this.orderInfo.status == "Declined"
      ) {
        let element = this.$refs.textfieldInput.$el.querySelector("input");

        this.$nextTick(() => {
          element.select();
        });
      }
    },
    setFieldValidationRules() {
      this.rules.phoneNumber = [
        (v) => !!v || this.$t(["Required"]),
        (v) => (v || "").length >= 14 || this.$t(["Invalid phone number"]),
      ];
    },
    async completeOrder() {
      this.competeBtnLoading = true;

      try {
        await Auth.currentSession().then(async (data) => {
          await this.statusStore
            .updateOrderStatus(
              {
                eventName: this.authStore.runSiteInfo.eventName,
                orderId: this.orderInfo.id,
                status: "Completed",
              },
              data.idToken.jwtToken
            )
            .then((response) => {
              // console.log(response);

              if (response.success) {
                localStorage.removeItem("status");

                this.$router.replace({
                  name: "OrderStatus",
                  params: {
                    success: true,
                    message: this.$gettext("Successfully completed order"),
                  },
                });
              } else {
                throw response.message;
              }
            });
        });
      } catch (error) {
        this.errorMsgAlert = true;
        this.errorMsg = error.message == undefined ? error : error.message;

        this.$nextTick(() => {
          const el = this.$el.querySelector("snackbarError");
          this.$vuetify.goTo(-5, el);

          return;
        });
      }

      this.competeBtnLoading = false;
    },
    async resendOrder() {
      await this.setFieldValidationRules();

      if (this.$refs.orderStatusSummaryForm.validate()) {
        this.resendBtnLoading = true;

        try {
          await Auth.currentSession().then(async (data) => {
            await this.statusStore
              .resendOrderApi(
                {
                  eventName: this.authStore.runSiteInfo.eventName,
                  orderAliasId: this.orderInfo.orderAliasId,
                  newPhoneNumber: this.orderInfo.phoneNumber,
                  newLanguage: this.$i18n.locale,
                },
                data.idToken.jwtToken
              )
              .then((response) => {
                // console.log(response);

                if (response.success) {
                  localStorage.removeItem("status");

                  this.$router.replace({
                    name: "OrderStatus",
                    params: {
                      success: true,
                      message: this.$gettext(
                        "Successfully resent order form SMS"
                      ),
                    },
                  });
                } else {
                  throw response.message;
                }
              });
          });
        } catch (error) {
          this.errorMsgAlert = true;
          this.errorMsg = error.message == undefined ? error : error.message;

          this.$nextTick(() => {
            const el = this.$el.querySelector("snackbarError");
            this.$vuetify.goTo(-5, el);

            return;
          });
        }

        this.resendBtnLoading = false;
      }
    },
    async voidOrder() {
      this.voidBtnLoading = true;

      try {
        await Auth.currentSession().then(async (data) => {
          await this.statusStore
            .updateOrderStatus(
              {
                eventName: this.authStore.runSiteInfo.eventName,
                orderId: this.orderInfo.id,
                status: "Voided",
              },
              data.idToken.jwtToken
            )
            .then((response) => {
              // console.log(response);

              if (response.success) {
                localStorage.removeItem("status");

                this.$router.replace({
                  name: "OrderStatus",
                  params: {
                    success: true,
                    message: this.$gettext("Successfully voided order"),
                  },
                });
              } else {
                throw response.message;
              }
            });
        });
      } catch (error) {
        this.errorMsgAlert = true;
        this.errorMsg = error.message == undefined ? error : error.message;

        this.$nextTick(() => {
          const el = this.$el.querySelector("snackbarError");
          this.$vuetify.goTo(-5, el);

          return;
        });
      }

      this.voidBtnLoading = false;
    },
    generateQrCode() {
      const orderFormURL = `${this.formUrl}?id=${this.orderInfo.orderAliasId}`;

      QRCode.toDataURL(orderFormURL)
        .then((url) => {
          this.qrCodeUrl = url;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    async goToRefundRequest() {
      let data = this.$route.params.data;

      if (this.orderInfo.refundData.refundRequestId != null) {
        this.$router.push({
          name: "PendingRefund",
          params: { data: data },
        });
      } else {
        this.$router.push({
          name: "RequestRefund",
          params: { data: data },
        });
      }
    },
    backToOrderStatus() {
      localStorage.removeItem("status");
      this.$router.replace("/orderStatus");
    },
  },
};
</script>

<style lang="scss" scoped></style>
